import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "aws-amplify";
import { OutlineType, SelectedTopicsType } from "../brief/types";

import * as Sentry from "@sentry/nextjs";


const getCloudFrontUrl = () => {
  if (
    process.env.NEXT_PUBLIC_BRANCH === "dev" ||
    process.env.NODE_ENV === "development"
  ) {
    return "https://py-staging.seowind.io";
  }
  if (process.env.NEXT_PUBLIC_BRANCH === "staging") {
    return "https://py-staging.seowind.io";
  }
  return "https://py.seowind.io";
};


export const getUserDetails = createAsyncThunk(
  "auth/getUserDetails",
  async () => {
    try {
      return await API.get("auth", `/auth/user/get-user-id`, {});
    }
    catch (err) {
      Sentry.captureException(err);
      throw err;
    }
  }
);

export const generateArticle = createAsyncThunk(
  "articles/generateArticle",
  async ({
    briefId,
    title,
    selectedTopics,
    selectedOutlines,
    keyword,
    userId,
    aiWordsLeft,
    language,
    location,
    addCompanyInfo,
    addStats,
    addInsights,
    projectDomain,
    GSCsiteUrl,
    addInterlinking,
    humanize,
    thoughtLeadership,
    searchIntentUrls,
    aiResearchAgent,
    aiEvalRefineAgent,
  }: {
    briefId: string;
    title: string;
    keyword: string;
    selectedTopics: SelectedTopicsType[];
    selectedOutlines: OutlineType[];
    userId: string;
    aiWordsLeft: number;
    language: string;
    location: string;
    addCompanyInfo: boolean;
    addStats: boolean
    addInsights: boolean;
    projectDomain: string;
    GSCsiteUrl: string;
    addInterlinking: boolean;
    humanize: boolean;
    thoughtLeadership: boolean;
    searchIntentUrls: string[];
    aiResearchAgent: boolean;
    aiEvalRefineAgent: boolean;
  }) => {
    addStats = false;
    thoughtLeadership = false;

    const url = getCloudFrontUrl();

    // const url = "http://localhost:4100"

    console.log('[generateArticle] Starting article generation:', {
      briefId,
      keyword,
      title,
      userId,
      topicsCount: selectedTopics.length,
      outlinesCount: selectedOutlines.length
    });

    try {
      const data = await fetch(`${url}/article/generate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          briefId,
          title,
          selectedTopics,
          selectedOutlines,
          keyword,
          userId,
          aiWordsLeft,
          language,
          location,
          addCompanyInfo,
          addStats,
          addInsights,
          projectDomain,
          GSCsiteUrl,
          addInterlinking,
          humanize,
          thoughtLeadership,
          searchIntentUrls,
          aiResearchAgent,
          aiEvalRefineAgent,
        }),
      });

      console.log('[generateArticle] Response received:', data.status, data.statusText);

      const result = await data.json();
      console.log('[generateArticle] Article generation response:', result);

      return result;
    } catch (err) {
      console.error('[generateArticle] Error generating article:', err);
      Sentry.captureException(err);
      throw err;
    }
  }
);
export const getArticle = createAsyncThunk(
  "articles/getArticle",
  async ({ id }: { id: string }) => {
    const url = getCloudFrontUrl();

    // const url = "http://localhost:4100";
    try {

      const data = await fetch(`${url}/article/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          briefId: id,
        }),
      });
      return data.json();
    } catch (err) {
      Sentry.captureException(err);
      console.log(err);
    }
  }
);

// humanize article
export const humanizeArticle = createAsyncThunk(
  "articles/humanizeArticle",
  async ({ text }: { text: string }) => {
    const url = getCloudFrontUrl();
    // const url = "http://localhost:4100";
    try {
      const data = await fetch(`${url}/humanizer/humanize`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text,
        }),
      });
      return data;
    } catch (err) {
      Sentry.captureException(err);
      console.log(err);
    }
  }
);

export const updateArticle = createAsyncThunk(
  "articles/updateArticle",
  async ({ id, content, isHumanized, isEdited, charCount }: { id: string; content: string; isHumanized: boolean, isEdited: boolean, charCount?: number }) => {
    const url = getCloudFrontUrl();
    // const url = "http://localhost:4100";
    try {
      const data = await fetch(`${url}/article/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ briefId: id, content, isHumanized, isEdited, charCount }),
      });
      return data.json();
    } catch (err) {
      Sentry.captureException(err);
      console.log(err);
    }

  }
);

export const deleteArticle = createAsyncThunk(
  "articles/deleteArticle",
  async ({ briefId }: { briefId: string }) => {
    const url = getCloudFrontUrl();
    // const url = "http://localhost:4100";
    try {
      const data = await fetch(`${url}/article/delete`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ briefId }),
      });
      return data.json();
    } catch (err) {
      Sentry.captureException(err);
      console.log(err);
      throw err;
    }
  }
);
